/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectDateModalCustomStyles, selectDateModalCustomStylesMobileExtended } from '@brands/Utils/customStyles';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { formatTimeForApi, formatTimeForDisplay } from '@brands/Utils/formatTime';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import moment from 'moment';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { BsPlusCircleFill, BsTrash3 } from 'react-icons/bs';
import { HiPlusCircle } from 'react-icons/hi';
import Modal from 'react-modal';
import { toast } from 'react-toastify';

import Button from '../../../../../../../Components/Button/Button';
import Calendar from '../../../../../../../Components/Calendar/Calendar';
import { Loading } from '../../../../../../../Components/LoadingSpinner/Loading';
import { generateTimeOptions } from '../../../../../../../Components/TimeInput/assets/options';
import TimeInput from '../../../../../../../Components/TimeInput/TimeInput';
import { useWindowSize } from '../../../../../../../hooks';
import { useAppSelector } from '../../../../../../../hooks/useReduxHook';
import { addUserAvailability } from '../../../../../../../services/availability/addUserAvailability';
import { checkUserAvailability } from '../../../../../../../services/availability/checkUserAvailability';
import { deleteUserAvailability } from '../../../../../../../services/availability/deleteUserAvailability';
import { ProviderAvailability } from '../../../../../../../services/availability/types/ProviderAvailability';
import { updateUserAvailability } from '../../../../../../../services/availability/updateUserAvailability';
import { ICase, Status } from '../../../../../../../services/cases/types/ICase';
import { getPrimaryColor } from '../../../../../../../Utils/getPrimaryColor';
import { Option } from '../../../../../../../Utils/selectOptions';
import styles from './styles.module.scss';

interface SelectDateModalProps {
  addDateModal: boolean;
  setAddDateModal: (bool: boolean) => void;
  dateOverrides: ProviderAvailability[];
  setDateOverrides: React.Dispatch<React.SetStateAction<ProviderAvailability[]>>;
  weeklyAvailabilities: ProviderAvailability[];
  selectedDates: Date[] | null;
  setSelectedDates: React.Dispatch<React.SetStateAction<Date[] | null>>;
  timezone: string;
  setAlertModal: React.Dispatch<
    React.SetStateAction<{
      cases: ICase[];
      kind: 'override' | 'weekly';
      type: 'delete' | 'update' | 'add';
      selectedDates?: Date[];
      isUnavailable?: boolean;
      slots: ProviderAvailability[];
      overrideSlots?: OverrideHour[];
    } | null>
  >;
  setRequestSending: React.Dispatch<React.SetStateAction<boolean>>;
  editingOverrideDates?: Date[] | null;
  setEditingOverrideDates?: React.Dispatch<React.SetStateAction<Date[] | null>>;
}

export interface OverrideHour {
  start: string;
  end: string;
  type: string[];
  id: number;
}

interface Hour {
  start: string;
  end: string;
  type: string[];
  id: number;
}

export const addProviderUnavailability = async (
  userId: number,
  date: Date,
  setValues: (value: React.SetStateAction<ProviderAvailability[]>) => void,
): Promise<void> => {
  try {
    await addUserAvailability(userId, {
      type: 'date',
      date: moment(date).format('YYYY-MM-DD'),
      start_time: '00:00:00',
      end_time: '23:59:59',
      synchronous: false,
      asynchronous: false,
    }).then((res) => {
      if (res) {
        setValues((prev) => [
          ...prev,
          {
            ...res,
            start_time: formatTimeForDisplay(res.start_time),
            end_time: formatTimeForDisplay(res.end_time),
          },
        ]);
      }
    });
  } catch (error: unknown) {
    displayErrorDetails(error);
  }
};

const SelectDate: FC<SelectDateModalProps> = ({
  addDateModal,
  setAddDateModal,
  dateOverrides,
  setDateOverrides,
  weeklyAvailabilities,
  selectedDates,
  setSelectedDates,
  timezone,
  setAlertModal,
  setRequestSending,
  editingOverrideDates,
  setEditingOverrideDates,
}) => {
  const { userInfo } = useAppSelector(selectAuth);
  const screenSize = useWindowSize();

  const [loading, setLoading] = useState(false);
  const [overrideHours, setOverrideHours] = useState<OverrideHour[]>([]);

  useEffect(() => {
    if (editingOverrideDates && editingOverrideDates.length > 0) {
      setSelectedDates(editingOverrideDates);
      const dateStr = moment(editingOverrideDates[0]).format('YYYY-MM-DD');
      const existingSlots = dateOverrides.filter((o) => o.date === dateStr);
      const isAllDayUnavailable =
        existingSlots.length === 1 &&
        existingSlots[0].start_time === '12:00am' &&
        existingSlots[0].end_time === '11:59pm';
      if (existingSlots.length > 0 && !isAllDayUnavailable) {
        setOverrideHours(
          existingSlots.map((o, i) => ({
            start: o.start_time,
            end: o.end_time,
            type: [...(o.synchronous ? ['synchronous'] : []), ...(o.asynchronous ? ['asynchronous'] : [])],
            id: i,
          })),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dateOverrides is guaranteed loaded before edit mode can be triggered (user must click an existing override to open this modal)
  }, [editingOverrideDates]);

  const endTimeOptions = (hour: ProviderAvailability): Option[] => {
    let filteredTimeOptions = generateTimeOptions(false);

    if (hour.start_time) {
      const startTimeId = filteredTimeOptions.find((option) => option.value === hour.start_time)?.id;

      if (startTimeId) {
        filteredTimeOptions = filteredTimeOptions.filter((option) => Number(option.id) >= Number(startTimeId) + 1);
      }
    }

    return filteredTimeOptions;
  };
  const startTimeOptions = (hour: ProviderAvailability, isToday: boolean): Option[] => {
    let filteredTimeOptions = generateTimeOptions(true);

    if (hour.end_time) {
      const endTimeId = filteredTimeOptions.find((option) => option.value === hour.end_time)?.id;
      if (endTimeId) {
        filteredTimeOptions = filteredTimeOptions.filter((option) => Number(option.id) <= Number(endTimeId) - 1);
      }
    }

    // if (isToday) {
    //   const now = new Date();
    //   const currentHour = now.getHours();
    //   const currentMinute = now.getMinutes();

    //   const currentMeridiem = currentHour < 12 ? 'am' : 'pm';
    //   const currentHour12 = currentHour === 0 || currentHour === 12 ? '12' : (currentHour % 12).toString();
    //   const currentMinute30 = currentMinute < 30 ? '30' : '00';
    //   const currentTime = `${currentHour12}:${currentMinute30}${currentMeridiem}`;

    //   const currentTimeIndex = filteredTimeOptions.findIndex((option) => option.value === currentTime);
    //   filteredTimeOptions = filteredTimeOptions.slice(currentTimeIndex + 1);
    // }

    return filteredTimeOptions;
  };

  const todaysTimeOptions = useMemo(() => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const currentMeridiem = currentHour < 12 ? 'am' : 'pm';
    const currentHour12 = currentHour === 0 || currentHour === 12 ? '12' : (currentHour % 12).toString();
    const currentMinute30 = currentMinute < 30 ? '30' : '00';
    const currentTime = `${currentHour12}:${currentMinute30}${currentMeridiem}`;

    const currentTimeIndex = generateTimeOptions(true).findIndex((option) => option.value === currentTime);

    return generateTimeOptions(true)
      .slice(currentTimeIndex + 1)
      .filter((option) => option.value !== '12:00am');
  }, [generateTimeOptions]);

  function addNewRow(): void {
    setOverrideHours((prev) => [
      ...prev,
      {
        start: '',
        end: '',
        type: UserRoleName.Provider === userInfo.role.name ? [] : ['synchronous', 'asynchronous'],
        id: prev.length,
      },
    ]);
  }

  const convertTimeFormat = (time: string): string => {
    const convertedTime = formatTimeForDisplay(time);
    return convertedTime;
  };

  const formatAvailabilityForState = (availability: ProviderAvailability): ProviderAvailability => ({
    ...availability,
    start_time: convertTimeFormat(availability.start_time),
    end_time: convertTimeFormat(availability.end_time),
  });

  const replaceDateOverrides = async (
    existingSlots: ProviderAvailability[],
    replacementSlots: ProviderAvailability[],
  ): Promise<void> => {
    const existingSlotsByDate = existingSlots.reduce<Record<string, ProviderAvailability[]>>((acc, slot) => {
      acc[slot.date] = [...(acc[slot.date] || []), slot];
      return acc;
    }, {});
    const replacementIndexByDate: Record<string, number> = {};
    const usedExistingSlotIds: number[] = [];
    const updatedSlots: ProviderAvailability[] = [];
    const addedSlots: ProviderAvailability[] = [];

    await Promise.all(
      replacementSlots.map(async (slot) => {
        const replacementIndex = replacementIndexByDate[slot.date] || 0;
        replacementIndexByDate[slot.date] = replacementIndex + 1;
        const existingSlot = existingSlotsByDate[slot.date]?.[replacementIndex];

        if (existingSlot?.id) {
          usedExistingSlotIds.push(existingSlot.id);
          const updatedSlot = await updateUserAvailability(userInfo.id, existingSlot.id, {
            start_time: slot.start_time,
            end_time: slot.end_time === '11:59pm' ? '23:59:59' : slot.end_time,
            synchronous: slot.synchronous,
            asynchronous: slot.asynchronous,
          });
          updatedSlots.push(updatedSlot);
          return;
        }

        const otherSlotsAtSameRequest = replacementSlots
          .filter((s) => !(s.date === slot.date && s.start_time === slot.start_time))
          .map((otherSlot) => ({ ...otherSlot, created_at: null }));
        const addedSlot = await addUserAvailability(userInfo.id, {
          ...slot,
          other_slots_at_same_request: otherSlotsAtSameRequest,
        });
        addedSlots.push(addedSlot);
      }),
    );

    const slotsToDelete = existingSlots.filter((slot) => slot.id && !usedExistingSlotIds.includes(slot.id));

    await Promise.all(
      slotsToDelete.map(async (slot) => {
        if (slot.id) await deleteUserAvailability(userInfo.id, slot.id.toString());
      }),
    );

    const updatedSlotMap = new Map(updatedSlots.map((slot) => [slot.id, formatAvailabilityForState(slot)]));
    const deletedSlotIds = slotsToDelete.map((slot) => slot.id);

    setDateOverrides((prev) => [
      ...prev
        .filter((prevOverride) => !deletedSlotIds.includes(prevOverride.id))
        .map((prevOverride) => updatedSlotMap.get(prevOverride.id) || prevOverride),
      ...addedSlots.map(formatAvailabilityForState),
    ]);
  };

  const checkAllFieldsFilledForOverrideHours = (overrides: OverrideHour[]): boolean => {
    const isStartTimeEmpty = overrides.some((hour) => hour.start === '');
    const isEndTimeEmpty = overrides.some((hour) => hour.end === '');
    const isTypeEmpty = overrides.some((hour) => hour.type.length === 0);
    if (isTypeEmpty && userInfo.role.name === UserRoleName.Provider)
      toast.error('At least one of the consultation types must be selected.');
    if (isStartTimeEmpty) toast.error('Start time must be selected.');
    if (isEndTimeEmpty) toast.error('End time must be selected.');
    return isStartTimeEmpty || isEndTimeEmpty || (isTypeEmpty && userInfo.role.name === UserRoleName.Provider);
  };

  const isTypeMatching = (dateOverridedHour: any, types: string[]): boolean => {
    return types.some(
      (type) =>
        (type === 'synchronous' && dateOverridedHour.synchronous) ||
        (type === 'asynchronous' && dateOverridedHour.asynchronous),
    );
  };

  const isTimeOverlapping = (
    newStart: moment.Moment,
    newEnd: moment.Moment,
    oldStart: moment.Moment,
    oldEnd: moment.Moment,
  ): boolean => {
    return (
      newStart.isSame(oldStart) ||
      newStart.isBetween(oldStart, oldEnd) ||
      newEnd.isSame(oldEnd) ||
      newEnd.isBetween(oldStart, oldEnd) ||
      (newStart.isBefore(oldStart) && newEnd.isAfter(oldEnd))
    );
  };

  const checkNewOverridesHaveOverlapsWithValuesOfPreviousOverridesOnSameDate = (
    override: OverrideHour,
  ): ProviderAvailability[] => {
    const editingDateStrs = editingOverrideDates ? editingOverrideDates.map((d) => moment(d).format('YYYY-MM-DD')) : [];
    let overlappedHours: ProviderAvailability[] = [];
    if (selectedDates && selectedDates.length > 0) {
      selectedDates.forEach((date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        const dateOverrided = editingDateStrs.includes(formattedDate)
          ? []
          : dateOverrides.filter((dateOverride) => dateOverride.date === formattedDate);
        if (dateOverrided.length > 0) {
          if (
            dateOverrided.find(
              (dateOverridedHour) =>
                dateOverridedHour.start_time === '12:00am' && dateOverridedHour.end_time === '11:59pm',
            )
          ) {
            overlappedHours = [];
          } else {
            dateOverrided.forEach((dateOverridedHour) => {
              if (isTypeMatching(dateOverridedHour, override.type)) {
                const newStartTime = moment(override.start, 'h:mmA');
                const newEndTime = moment(override.end, 'h:mmA');
                const oldStartTime = moment(dateOverridedHour.start_time, 'h:mmA');
                const oldEndTime = moment(dateOverridedHour.end_time, 'h:mmA');

                if (isTimeOverlapping(newStartTime, newEndTime, oldStartTime, oldEndTime)) {
                  overlappedHours = [...overlappedHours, dateOverridedHour];
                }
              }
            });
          }
        }
      });
    }
    return overlappedHours;
  };

  const checkNewOverridesHaveOverlaps = (overrides: OverrideHour[]): boolean => {
    for (let i = 0; i < overrides.length - 1; i += 1) {
      const slotAStart = moment(overrides[i].start, 'h:mmA');
      const slotAEnd = moment(overrides[i].end, 'h:mmA');
      for (let j = i + 1; j < overrides.length; j += 1) {
        const slotBStart = moment(overrides[j].start, 'h:mmA');
        const slotBEnd = moment(overrides[j].end, 'h:mmA');
        if (overrides[i].type.some((type) => overrides[j].type.includes(type))) {
          if (!(slotAEnd < slotBStart || slotAStart > slotBEnd)) {
            return true;
          }
        }
      }
    }

    return false;
  };

  const checkIsDeletePossible = async (
    availability: ProviderAvailability,
    unavailable_dates?: string[],
  ): Promise<ICase[]> => {
    if (!availability) return [];
    if (UserRoleName.Provider !== userInfo.role.name) return [];

    const res = await checkUserAvailability(
      userInfo.id,
      {
        availability_id: availability.id || undefined,
        unavailable_dates,
      },
      userInfo.role.name,
    );
    return res?.length > 0 ? res : [];
  };

  const isActiveCase = (caseItem: ICase): boolean =>
    caseItem.status !== Status.Canceled && caseItem.status !== Status.Deleted && caseItem.status !== Status.Completed;

  const compareProviderAvailability = async (
    availability: ProviderAvailability,
    otherSlotsAtSameRequest: ProviderAvailability[],
  ): Promise<ICase[]> => {
    if (!availability) return [];
    if (UserRoleName.Provider !== userInfo.role.name) return [];

    return checkUserAvailability(
      userInfo.id,
      {
        type: availability.type as unknown as 'date' | 'weekday' | undefined,
        date: availability.date,
        start_time: moment(availability.start_time, 'h:mmA').format('HH:mm:ss'),
        end_time:
          availability.end_time === '11:59pm' ? '23:59:59' : moment(availability.end_time, 'h:mmA').format('HH:mm:ss'),
        synchronous: availability.synchronous,
        asynchronous: availability.asynchronous,
        other_slots_at_same_request: otherSlotsAtSameRequest,
      },
      userInfo.role.name,
    );
  };

  const alignWeekdays = (weekday: number): number => {
    if (weekday === 0) return 6;
    return weekday - 1;
  };

  const getAllAvailabilitiesForSelectedDates = (): {
    overridesForSelectedDates: ProviderAvailability[];
    allAvailabilitiesForSelectedDates: ProviderAvailability[];
  } => {
    if (selectedDates && selectedDates.length > 0) {
      const overridesForSelectedDates = dateOverrides.filter((override) =>
        selectedDates.some((date) => override.date === moment(date).format('YYYY-MM-DD')),
      );
      const availabilitiesForSelectedDates: ProviderAvailability[] = [];

      selectedDates.forEach((date) => {
        const weekday = alignWeekdays(moment(date).day());
        weeklyAvailabilities.forEach((availability) => {
          if (availability.weekday === weekday) {
            availabilitiesForSelectedDates.push(availability);
          }
        });
      });
      const allAvailabilitiesForSelectedDates = [...availabilitiesForSelectedDates, ...overridesForSelectedDates];
      return {
        overridesForSelectedDates,
        allAvailabilitiesForSelectedDates,
      };
    }
    return {
      overridesForSelectedDates: [],
      allAvailabilitiesForSelectedDates: [],
    };
  };

  const onSubmit = (): void => {
    (async (): Promise<void> => {
      setLoading(true);
      setRequestSending(true);

      if (checkAllFieldsFilledForOverrideHours(overrideHours)) {
        setLoading(false);
        setRequestSending(false);
        setSelectedDates([]);
        return;
      }

      let overlappedHours: ProviderAvailability[] = [];
      let isOverlapped = false;

      if (selectedDates && selectedDates.length > 0) {
        await Promise.all(
          selectedDates.map(() => {
            isOverlapped = overrideHours.length > 0 ? checkNewOverridesHaveOverlaps(overrideHours) : false;
            if (isOverlapped) return;
            overrideHours.forEach((hour) => {
              overlappedHours = checkNewOverridesHaveOverlapsWithValuesOfPreviousOverridesOnSameDate(hour);
            });
          }),
        );
      }

      if (isOverlapped || overlappedHours.length > 0) {
        setAddDateModal(false);
        setLoading(false);
        toast.error(
          'You already have an existing time slot that overlaps with this time. Please review your existing times and update this time slot accordingly.',
        );
        setLoading(false);
        setRequestSending(false);
        setSelectedDates([]);
        return;
      }

      if (selectedDates && selectedDates.length > 0) {
        try {
          const { overridesForSelectedDates, allAvailabilitiesForSelectedDates } =
            getAllAvailabilitiesForSelectedDates();
          // handle unavailable slots first
          if (overrideHours.length === 0) {
            const cases: ICase[] = [];
            const overrides: ProviderAvailability[] = [];
            const unavailableSlots = selectedDates.map(
              (date) =>
                ({
                  id: null,
                  type: 'date',
                  date: moment(date).format('YYYY-MM-DD'),
                  start_time: '00:00:00',
                  end_time: '23:59:59',
                  synchronous: false,
                  asynchronous: false,
                  created_at: '',
                  weekday: alignWeekdays(moment(date).day()),
                } as ProviderAvailability),
            );
            const unavailableDates = selectedDates.map((date) => moment(date).format('YYYY-MM-DD'));
            await Promise.all(
              allAvailabilitiesForSelectedDates.map(async (override) => {
                await checkIsDeletePossible(override, unavailableDates).then((res) => {
                  if (res && res.length > 0) {
                    cases.push(...res);
                  } else if (override.type === 'date') {
                    overrides.push(override);
                  }
                });
              }),
            );

            if (cases && cases.length > 0) {
              setAlertModal({
                cases,
                kind: 'override',
                type: 'delete',
                selectedDates: selectedDates || [],
                isUnavailable: true,
                slots: overridesForSelectedDates,
              });
            } else if (overrides.length > 0) {
              await replaceDateOverrides(overrides, unavailableSlots);
            } else {
              await Promise.all(
                selectedDates.map(async (date) => {
                  await addProviderUnavailability(userInfo.id, date, setDateOverrides);
                }),
              );
            }
            return;
          }

          const editingDateStrs = editingOverrideDates
            ? editingOverrideDates.map((date) => moment(date).format('YYYY-MM-DD'))
            : [];
          const editingSlotsToReplace =
            editingDateStrs.length > 0
              ? overridesForSelectedDates.filter((override) => editingDateStrs.includes(override.date))
              : [];
          const unavailableSlots = overridesForSelectedDates.filter(
            (override) => override.start_time === '12:00am' && override.end_time === '11:59pm',
          );
          const slotsToReplace = editingSlotsToReplace.length > 0 ? editingSlotsToReplace : unavailableSlots;
          const slots: ProviderAvailability[] = [];
          selectedDates.forEach((date) => {
            overrideHours.forEach((hour) => {
              slots.push({
                id: null,
                type: 'date',
                date: moment(date).format('YYYY-MM-DD'),
                start_time: formatTimeForApi(hour.start),
                end_time: hour.end === '11:59pm' ? '23:59:59' : formatTimeForApi(hour.end),
                synchronous: hour.type.includes('synchronous'),
                asynchronous: hour.type.includes('asynchronous'),
                created_at: '',
                weekday: alignWeekdays(moment(date).day()),
              });
            });
          });

          const cases: ICase[] = [];

          if (slotsToReplace.length > 0) {
            await Promise.all(
              slotsToReplace.map(async (slot) => {
                const res = await checkIsDeletePossible(slot);
                if (res && res.length > 0) {
                  cases.push(...res.filter(isActiveCase));
                }
              }),
            );
          }

          if (cases.length > 0) {
            setAlertModal({
              cases,
              kind: 'override',
              type: 'delete',
              selectedDates: selectedDates || [],
              slots: slotsToReplace,
              overrideSlots: overrideHours,
            });
            return;
          }

          await Promise.all(
            slots.map(async (slot) => {
              const otherSlotsAtSameRequest = slots.filter(
                (s) => !(s.date === slot.date && s.start_time === slot.start_time),
              );
              otherSlotsAtSameRequest.forEach((otherSlot) => {
                otherSlot.created_at = null;
              });
              const res = await compareProviderAvailability(slot, otherSlotsAtSameRequest);
              if (res && res.length > 0) cases.push(...res);
            }),
          );

          if (cases.length > 0) {
            setAlertModal({
              cases,
              kind: 'override',
              type: slotsToReplace.length > 0 ? 'delete' : 'add',
              selectedDates: selectedDates || [],
              slots: slotsToReplace.length > 0 ? slotsToReplace : slots,
              overrideSlots: slotsToReplace.length > 0 ? overrideHours : undefined,
            });
            return;
          }

          if (slotsToReplace.length > 0) {
            await replaceDateOverrides(slotsToReplace, slots);
            return;
          }

          await Promise.all(
            slots.map(async (slot) => {
              const otherSlotsAtSameRequest = slots
                .filter((s) => !(s.date === slot.date && s.start_time === slot.start_time))
                .map((otherSlot) => ({ ...otherSlot, created_at: null }));
              await addUserAvailability(userInfo.id, {
                ...slot,
                other_slots_at_same_request: otherSlotsAtSameRequest,
              }).then((r) => {
                setDateOverrides((prev) => [
                  ...prev,
                  {
                    ...r,
                    start_time: convertTimeFormat(r.start_time),
                    end_time: r.end_time === '11:59pm' ? '23:59:59' : convertTimeFormat(r.end_time),
                    synchronous: r.synchronous ?? slot.synchronous,
                    asynchronous: r.asynchronous ?? slot.asynchronous,
                  },
                ]);
              });
            }),
          );
        } catch (error: unknown) {
          setAddDateModal(false);
          setLoading(false);
          displayErrorDetails(error);
        } finally {
          setLoading(false);
          setAddDateModal(false);
          setSelectedDates([]);
          setRequestSending(false);
          if (setEditingOverrideDates) setEditingOverrideDates(null);
        }
      }
    })();
  };

  const isApplyButtonDisabled = ((dates: Date[] | null, overrides: OverrideHour[]): boolean => {
    if (!dates || dates.length === 0) return true;
    if (overrides.length > 0) {
      const isStartTimeEmpty = overrides.some((hour) => hour.start === '');
      const isEndTimeEmpty = overrides.some((hour) => hour.end === '');
      const isTypeEmpty = overrides.some((hour) => hour.type.length === 0);
      return isStartTimeEmpty || isEndTimeEmpty || (isTypeEmpty && userInfo.role.name === UserRoleName.Provider);
    }
    return false;
  })(selectedDates, overrideHours);

  const handleTimeChange = (val: Option, hour: OverrideHour, type: 'start' | 'end', index: number): void => {
    if (type === 'start' && hour.end) {
      let filteredTimeOptions = generateTimeOptions(false);

      const endTimeOption = generateTimeOptions(false).find((option) => option.value === hour.end);
      const endTimeId = endTimeOption?.id;
      const isEndTimeMidnight = hour.end === '12:00am';

      if (endTimeId) {
        filteredTimeOptions = generateTimeOptions(false).filter((option) => {
          return isEndTimeMidnight || Number(option.id) <= Number(endTimeId) - 1;
        });
      }

      if (!filteredTimeOptions.find((option) => option.value === val.value)) {
        toast.error('Start time must be at least 30 minutes before end time');
        return;
      }
    }

    setOverrideHours((prev) => {
      const newOverrides = [...prev];
      newOverrides[index][type] = val.value;
      return newOverrides;
    });
  };

  const getOptionFromHour = (hour: string): Option => {
    return {
      value: hour,
      label: hour,
    } as Option;
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, type: string, index: number): void => {
    const { checked } = e.target;

    setOverrideHours((prev) =>
      prev.map((override, i) =>
        i === index
          ? {
              ...override,
              type: checked ? [...override.type, type] : override.type.filter((t) => t !== type),
            }
          : override,
      ),
    );
  };

  const renderTimeInputContainer = (hour: Hour, index: number): JSX.Element => {
    // const isToday = selectedDates && selectedDates.length === 1 && selectedDates[0].getDate() === new Date().getDate();

    return (
      <div className={styles.selectHoursInputContainer} key={hour.id}>
        <TimeInput
          timeOptions={
            overrideHours[index].end
              ? startTimeOptions({ end_time: overrideHours[index].end } as ProviderAvailability, false)
              : // : isToday
                // ? todaysTimeOptions
                generateTimeOptions(true)
          }
          time={getOptionFromHour(hour.start)}
          onChange={(val) => handleTimeChange(val, hour, 'start', index)}
        />

        <span className={styles.selectHoursInputSeparator}>&mdash;</span>

        <TimeInput
          timeOptions={
            overrideHours[index].start
              ? endTimeOptions({ start_time: overrideHours[index].start } as ProviderAvailability)
              : // : isToday
                // ? todaysTimeOptions
                generateTimeOptions(false)
          }
          time={getOptionFromHour(hour.end)}
          onChange={(e) => handleTimeChange(e, hour, 'end', index)}
        />
        <div className={styles.selectHoursInputContainerRemove}>
          <button
            className={styles.selectHoursInputContainerRemove}
            type="button"
            onClick={() => addNewRow()}
            aria-label="Weekly Hours Body Row Add Selection Button"
            disabled={loading}
          >
            <AddIcon />
          </button>
        </div>
        <div className={styles.selectHoursInputContainerRemove}>
          <button
            className={styles.selectHoursInputContainerRemoveButton}
            type="button"
            onClick={() => setOverrideHours(overrideHours.filter((_, i) => i !== index))}
            aria-label="Remove time slot"
          >
            <BsTrash3 size={18} color={getPrimaryColor()} />
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {}, [overrideHours]);

  const renderCheckbox = (type: string, hour: Hour, index: number): JSX.Element => (
    <div className={styles.checkInput} key={type}>
      <div className="form-check m-0" style={{ minHeight: 'unset' }}>
        <input
          type="checkbox"
          name={type}
          className="form-check-input fs-unmask"
          checked={hour.type.includes(type)}
          onChange={(e) => handleCheckboxChange(e, type, index)}
        />
        <label className={`fs-unmask ${styles.selectHoursTypeSelectText}`} htmlFor={type}>
          {type === 'synchronous' ? 'Synchronous' : 'Asynchronous'}
        </label>
      </div>
    </div>
  );

  const renderSelectHoursType = (hour: Hour, index: number): JSX.Element => (
    <div className={styles.selectHoursType} key={hour.id}>
      <span className={`fs-unmask ${styles.selectHoursTitle}`}>Available for:</span>
      <div className={styles.selectHoursTypeSelect}>
        {renderCheckbox('synchronous', hour, index)}
        {renderCheckbox('asynchronous', hour, index)}
      </div>
    </div>
  );

  const renderUnavailabilityOfSelectedDates = (unavailable: boolean): JSX.Element | null => {
    return (
      <div
        className={styles.checkInput}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <div
          className={styles.unavailableCheckbox}
          style={{
            marginLeft: '16px',
            opacity: unavailable ? 1 : 0.6,
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={unavailable}
                onChange={(e) => {
                  if (!e.target.checked) {
                    // switching OFF → allow custom hours
                    setOverrideHours([
                      {
                        start: '',
                        end: '',
                        type: UserRoleName.Provider === userInfo.role.name ? [] : ['synchronous', 'asynchronous'],
                        id: -1,
                      },
                    ]);
                  } else {
                    // switching ON → unavailable all day
                    setOverrideHours([]);
                  }
                }}
                color="primary"
              />
            }
            label={
              <span className={`fs-unmask ${styles.selectHoursTypeSelectText}`} style={{ fontSize: '14px' }}>
                Unavailable all day (12:00am – 11:59pm)
              </span>
            }
          />
        </div>
      </div>
    );
  };

  const renderSelectHoursContainer = (hour: OverrideHour, index: number): JSX.Element | null => (
    <div className={`fs-unmask ${styles.selectHoursContainer}`}>
      <div className={styles.selectHoursWrapper}>
        <div className={styles.selectHours} key={hour.id}>
          {renderTimeInputContainer(hour, index)}
          {userInfo.role.name === UserRoleName.Provider && renderSelectHoursType(hour, index)}
          {/* {index !== overrideHours.length - 1 && <hr className={styles.selectHoursSeparator} />} */}
        </div>
      </div>
    </div>
  );

  const renderButtons = (): JSX.Element => {
    const buttonsContainerStyle = screenSize.width >= 1024 ? styles.btnContainer : styles.btnContainerOnMobile;

    return (
      <div className={buttonsContainerStyle}>
        <div
          className={`fs-unmask ${styles.cancelBtn}`}
          onClick={(): void => {
            setSelectedDates([]);
            setAddDateModal(false);
            if (setEditingOverrideDates) setEditingOverrideDates(null);
          }}
        >
          Cancel
        </div>
        <Button
          onClick={(): void => onSubmit()}
          className={`fs-unmask ${styles.customBtn}`}
          disabled={isApplyButtonDisabled}
          style={{
            backgroundColor: isApplyButtonDisabled ? '#D0D0D0' : '',
            border: isApplyButtonDisabled ? '#D0D0D0' : '',
          }}
        >
          Save override
        </Button>
      </div>
    );
  };

  const renderLoadingContent = (): JSX.Element => (
    <div className={styles.loadingContainer}>
      <Loading dotted />
    </div>
  );

  return (
    <Modal
      isOpen={addDateModal}
      style={screenSize.width > 1024 ? selectDateModalCustomStyles : selectDateModalCustomStylesMobileExtended}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.container}>
        {screenSize.width > 1024 ? (
          <button
            type="button"
            className={`fs-unmask ${styles.modalClose}`}
            data-micromodal-close=""
            onClick={() => {
              setAddDateModal(false);
              if (setEditingOverrideDates) setEditingOverrideDates(null);
            }}
            aria-label="Close modal"
          >
            <AiOutlineClose className={styles.icon} />
          </button>
        ) : (
          <button
            type="button"
            className={`fs-unmask ${styles.modalBack}`}
            data-micromodal-close=""
            onClick={() => {
              setAddDateModal(false);
              if (setEditingOverrideDates) setEditingOverrideDates(null);
            }}
            aria-label="Close modal"
          >
            <ArrowBackIosIcon className={styles.icon} />
            Back
          </button>
        )}
        {loading ? (
          renderLoadingContent()
        ) : (
          <div className={`fs-unmask ${styles.SelectOverrideModal}`}>
            <div className={`fs-unmask ${styles.SelectOverrideModalLeftSide}`}>
              <div className={`fs-unmask ${styles.title}`}>Select dates to override</div>
              <div className={styles.content}>
                <Calendar selectedDates={selectedDates} setSelectedDates={setSelectedDates} isProvider />
              </div>
            </div>
            <div className={`fs-unmask ${styles.SelectOverrideModalRightSide}`}>
              <div className={styles.content}>
                <div className={`fs-unmask ${styles.title}`}>What hours are you available?</div>
                <div className={`fs-unmask ${styles.timeZone}`}>
                  <span className={`fs-unmask ${styles.timeZoneTitle}`}>Timezone</span>
                  <span className={`fs-unmask ${styles.timeZoneValue}`}>{timezone}</span>
                </div>
                {selectedDates && selectedDates.length > 0 ? (
                  <>
                    {renderUnavailabilityOfSelectedDates(overrideHours.length === 0)}
                    {overrideHours.length > 0 && (
                      <>{overrideHours.map((hour, index) => renderSelectHoursContainer(hour, index))}</>
                    )}
                    {renderButtons()}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default SelectDate;
